<template>
  <div class="isotope-wrapper" v-if="offerList.length > 0">
    <div
      class="box_list isotope-item popular"
      v-for="offer in offerList"
      :key="offer.id"
    >
      <div class="row no-gutters">
        <div class="col-lg-5">
              <!-- <small v-if="offer.status==='1'">Featured</small> -->
          <figure>
            <small>{{ offer.event }}</small>
            <router-link :to="'/user-post-single/' + offer.id"
              ><img
                :src="
                  offer.file !== null
                    ? 'https://peekzy.in/backend/public/' +
                      offer.file
                    : 'https://peekzy.in/backend/public/assets/uploads/no-image.png'
                "
                class="img-fluid"
                :alt="offer.company_name"
                height="200px"
              />
              <div class="read_more"><span>Read More</span></div></router-link
            >
          </figure> 
        </div>
        <div class="col-lg-7">
          <div class="wrapper">
            <!-- <a href="#0" class="wish_bt"></a> -->

            <!-- <div v-html="offer.description">
              {{ offer.description }}
            </div> -->
            <p class="location">
              <span class="col-md-6 pull-right">
                <i class="fa fa-map-marker"></i> {{ offer.pincode }}
              </span>
              <span class="col-md-6 pull-left">
                <i class="fa fa-map"></i> {{ offer.location }}
              </span>
            </p>
              <span class="text-left" v-html="offer.short_description">
            </span>
            <br>
              <br>
            <!-- <span class="price" v-if="offer.offer_in == 'percent'">
              Discount Upto <strong>{{ offer.offer_value }}%</strong>
            </span>
            <span class="price" v-else>
              Upto
              <strong><i class="fa fa-inr"></i> {{ offer.offer_value }}</strong>
            </span> -->
            <strong class="mt-3" >Categories: <div class="child" v-for="cat in offer.categories" :key="cat.category_id">{{ ' '+cat.category}}</div></strong>  
          </div>  
          <ul>
            <li>
              <i class="icon_clock_alt"></i> <b>Validity:</b>
              {{ validity(offer.event_end) }}
            </li>
            <li>
              <div class="score">
                <span>Superb<em>0 Reviews</em></span
                ><strong>10</strong>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="box_list isotope-item popular">
      <div class="row no-gutters">
        <div class="col-lg-12">
          <center><h5 class="mt-3">No Matching Record Found.</h5></center>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import imagepath from "../services/variables.js";
export default {
  data() {
    return {
imagepath:imagepath
    }
  },
  mounted() {
  },
  props: {
    offerList: {
      type: Array,
    },
  },
  methods: {
    validity(date) {
      return moment(date).format("dddd, MMMM Do YYYY");
    },
  },
};
</script>
<style scoped>
.location {
  min-height: 150px;
  vertical-align: middle;
}

.box_list {
  min-height: 310px;
}
</style>